import styled from 'styled-components'

interface ImageComparisonProps {
  colorScheme: string;
}

export const ImageComparison = styled.div`
  position: relative;
  display: grid;
  max-width: 100%;
  max-height: 100%;
  overflow: hidden;
  touch-action: pan-y;
  user-select: none;
  width: 100%;
  height: ${({ theme }) => theme.rem(500)};

  ${({ theme }) => theme.mediaQuery.lg(`
    height: ${theme.rem(800)};
  `)}
`

export const ImageWrapper = styled.div`
  position: relative;
  grid-area: 1 / 1 / 2 / 2;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  user-select: none;
`

export const BeforeImageWrapper = styled(ImageWrapper)`
  will-change: clip-path;
  clip-path: inset(0 50% 0 0);
`

export const Image = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  box-sizing: border-box;
  object-fit: cover;
  object-position: center center;
`

export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg,rgba(255, 255, 255, 0) 65%, ${({ theme }) => theme.palette.green['400']} 100%);
`

export const SliderLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 2px;
  background-color: ${({ theme }) => theme.palette.grayscale['50']};
  z-index: 2;
  cursor: ew-resize;

  .SliderLineTop {
    position: absolute;
    top: 0;
    left: -33px;

    path {
      fill: ${({ theme }) => theme.palette.grayscale['50']};
    }
  }

  .SliderLineBottom {
    position: absolute;
    bottom: 0;
    left: -33px;

    path {
      fill: ${({ theme }) => theme.palette.grayscale['50']};
    }
  }
`

export const SliderHandle = styled.div<ImageComparisonProps>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${({ theme }) => theme.rem(88)};
  height: ${({ theme }) => theme.rem(48)};
  border-radius: ${({ theme }) => theme.rem(8)};
  background-color: ${({ theme, colorScheme}) => theme.colorScheme[colorScheme].imageComparison.sliderHandle};
  cursor: ew-resize;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);

  i {
    color: ${({ theme, colorScheme}) => theme.colorScheme[colorScheme].imageComparison.sliderHandleIcon};
  }
`

export const Label = styled.span`
  position: absolute;
  bottom: ${({ theme }) => theme.rem(16)};
  padding: ${({ theme }) => `${theme.rem(8)} ${theme.rem(16)}`};
  color: ${({ theme }) => theme.palette.grayscale['50']};
  font-size: ${({ theme }) => theme.rem(16)};
  border-radius: ${({ theme }) => theme.rem(4)};
  z-index: 1;
`

export const BeforeLabel = styled(Label)`
  left: ${({ theme }) => theme.rem(16)};

  ${({ theme }) => theme.mediaQuery.lg(`
    left: ${theme.rem(116)};
  `)}
`

export const AfterLabel = styled(Label)`
  right: ${({ theme }) => theme.rem(16)};

  ${({ theme }) => theme.mediaQuery.lg(`
    right: ${theme.rem(116)};
  `)}
`
